export const isMobile = () => {
    return window.matchMedia('(max-width: 1024px)').matches;
};
export const isDesktop = () => {
    return window.matchMedia('(min-width: 1025px)').matches;
};
export const isTabletPortrait = () => {
    return window.matchMedia('(max-width: 960px)').matches;
};
